import { render } from "./InfiniteScroll.vue?vue&type=template&id=a2877df6&scoped=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"

import "./InfiniteScroll.vue?vue&type=style&index=0&id=a2877df6&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2877df6"]])

export default __exports__